import { Box } from '@mui/material';
import InfoTooltip from '@/components/InfoTooltip/InfoTooltip';
import CpdTextField from '@/components/ui/CpdTextField';

const ConfigurationField = ({
  name,
  label,
  value,
  onChange,
  error,
  type = 'text',
  tooltip,
  disabled,
  required = true,
}) => (
  <CpdTextField
    id={name}
    name={name}
    label={
      <Box
        component='span'
        sx={{ display: 'inline-flex', alignItems: 'center' }}>
        {label}
        {tooltip && <InfoTooltip title={tooltip} />}
      </Box>
    }
    value={value}
    onChange={onChange}
    error={Boolean(error)}
    helperText={error}
    type={type}
    disabled={disabled}
    required={required}
    InputLabelProps={{ shrink: true }}
    sx={{ mb: 0 }}
  />
);

export default ConfigurationField;
